<template>
    <div>
        <nav class="panel" v-for="address of orderInfo.addresses" v-bind:key="address.email">
            <p class="panel-heading">
                {{address.type | capitalize}} address
            </p>
            <div class="panel-block">
                <div class="columns" style="width:100%">
                    <div class="column is-half">
                        <table
                                class="table table-mobile-card"
                                style="width: 100%"
                        >
                            <tbody>

                                <tr v-if="address.firstname">
                                    <td>
                                        <b>First name</b>
                                    </td>
                                    <td>
                                        {{address.firstname}}
                                    </td>
                                </tr>
                                <tr v-if="address.lastname">
                                    <td>
                                        <b>Last name</b>
                                    </td>
                                    <td>
                                        {{address.lastname}}
                                    </td>
                                </tr>
                                <tr v-if="address.company">
                                    <td>
                                        <b>Company</b>
                                    </td>
                                    <td>
                                        {{address.company}}
                                    </td>
                                </tr>
                                <tr v-if="address.email">
                                    <td>
                                        <b>Email</b>
                                    </td>
                                    <td>
                                        {{address.email}}
                                    </td>
                                </tr>
                                <tr v-if="address.phone">
                                    <td>
                                        <b>Phone</b>
                                    </td>
                                    <td>
                                        {{address.phone}}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div class="column is-half">
                        <table
                                class="table"
                                style="width: 100%"
                        >
                            <tbody>
                                <tr v-if="address.street1">
                                    <td>
                                        <b>Street 1</b>
                                    </td>
                                    <td>
                                        {{address.street1}}
                                    </td>
                                </tr>
                                <tr v-if="address.street2">
                                    <td>
                                        <b>Street 2</b>
                                    </td>
                                    <td>
                                        {{address.street2}}
                                    </td>
                                </tr>
                                <tr v-if="address.zip">
                                    <td>
                                        <b>Zip</b>
                                    </td>
                                    <td>
                                        {{address.zip}}
                                    </td>
                                </tr>
                                <tr v-if="address.city">
                                    <td>
                                        <b>City</b>
                                    </td>
                                    <td>
                                        {{address.city}}
                                    </td>
                                </tr>
                                <tr v-if="address.state">
                                    <td>
                                        <b>State</b>
                                    </td>
                                    <td>
                                        {{address.state}}
                                    </td>
                                </tr>
                                <tr v-if="address.country">
                                    <td>
                                        <b>Country</b>
                                    </td>
                                    <td>
                                        {{address.country}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
  props: {
    orderInfo: Object
  },

  data () {
    return {
    }
  },
  methods: {}
}
</script>
